module.exports = __webpack_public_path__ + "6432e23130fbfa3ed7d13d359cc9329c.svg";